// Shared helpers for client-side signature + draft placeholder substitution.
// Available tokens (case-insensitive). Missing fields render as empty string.
//   {{company}}       → lead.company
//   {{website}}       → lead.website
//   {{role}}          → lead.decision_maker_role
//   {{headcount}}     → lead.headcount / lead.est_size
//   {{first_name}}    → best-effort guess from the role field, falls back to "there"
//   {{linkedin}}      → lead.linkedin_url
//   {{sender_name}}   → user.name or email prefix
//   {{sender_email}}  → user.email

const TOKEN_RE = /\{\{\s*([a-z_]+)\s*\}\}/gi;

function _firstNameGuess(role) {
  // Role is usually a title like "VP of Sales" or "Head of Growth" — rarely contains a name.
  // Return "there" so greetings read naturally when no real name is available.
  const trimmed = (role || "").trim();
  if (!trimmed) return "there";
  // If the role actually contains a leading proper-noun token that's not a title keyword,
  // use it (e.g., "John Smith, VP of Sales"). Otherwise fall back.
  const titleWords = new Set([
    "vp", "head", "director", "manager", "chief", "founder", "ceo", "coo", "cto",
    "cfo", "president", "owner", "lead", "principal", "senior", "junior", "of",
  ]);
  const first = trimmed.split(/[\s,]+/)[0] || "";
  if (first && !titleWords.has(first.toLowerCase()) && /^[A-Z][a-z]+$/.test(first)) {
    return first;
  }
  return "there";
}

export function buildPlaceholderMap(lead, user) {
  const l = lead || {};
  const u = user || {};
  const emailPrefix = (u.email || "").split("@")[0] || "";
  return {
    company: l.company || "",
    website: l.website || "",
    role: l.decision_maker_role || "",
    headcount: l.headcount || l.est_size || "",
    first_name: _firstNameGuess(l.decision_maker_role),
    linkedin: l.linkedin_url || "",
    sender_name: u.name || emailPrefix,
    sender_email: u.email || "",
  };
}

export function replacePlaceholders(text, lead, user) {
  if (!text) return "";
  const map = buildPlaceholderMap(lead, user);
  return text.replace(TOKEN_RE, (_, token) => {
    const key = token.toLowerCase();
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : `{{${token}}}`;
  });
}

// Catalogue of tokens shown to users as insertable chips.
export const SIGNATURE_TOKENS = [
  { token: "{{first_name}}", label: "First name" },
  { token: "{{company}}", label: "Company" },
  { token: "{{role}}", label: "Role" },
  { token: "{{headcount}}", label: "Headcount" },
  { token: "{{website}}", label: "Website" },
  { token: "{{sender_name}}", label: "Your name" },
  { token: "{{sender_email}}", label: "Your email" },
];
